export const SKELETON_CARD_COUNT = 6;

export const PROGRESS_CARD_WIDTH = 312;
export const REQUEST_CARD_WIDTH = 290;
export const CARD_SKELETON_HEIGHT = 135;
